import { Provider } from '@angular/core';
import {
  DeleteVesselShiftResourceItemUseCase,
  DeleteVesselShiftUseCase,
  GetVesselShiftResourceFormUseCase,
  GetVesselShiftResourceItemAuditLogsUseCase,
  ListVesselShiftResourceItemsUseCase,
  ListVesselShiftResourceTypesUseCase,
  ListVesselShiftsUseCase,
  LoadVesselShiftsUseCase,
  SaveVesselShiftResourceItemsUseCase,
  UpdateVesselShiftUseCase,
} from '@app/application/use-cases/vessel-shift-resource';
import { VesselShiftResourceRepository } from '@app/domain/repositories/vessel-shift-resource.repository';
import { VesselShiftResourceRepositoryImpl } from '../repositories/vessel-shift-resource.repository.impl';

export const VESSEL_SHIFT_RESOURCE_PROVIDERS: Provider[] = [
  {
    provide: VesselShiftResourceRepository,
    useClass: VesselShiftResourceRepositoryImpl,
  },
  {
    provide: ListVesselShiftsUseCase,
    useFactory: (repo: VesselShiftResourceRepository) =>
      new ListVesselShiftsUseCase(repo),
    deps: [VesselShiftResourceRepository],
  },
  {
    provide: LoadVesselShiftsUseCase,
    useFactory: (repo: VesselShiftResourceRepository) =>
      new LoadVesselShiftsUseCase(repo),
    deps: [VesselShiftResourceRepository],
  },
  {
    provide: UpdateVesselShiftUseCase,
    useFactory: (repo: VesselShiftResourceRepository) =>
      new UpdateVesselShiftUseCase(repo),
    deps: [VesselShiftResourceRepository],
  },
  {
    provide: DeleteVesselShiftUseCase,
    useFactory: (repo: VesselShiftResourceRepository) =>
      new DeleteVesselShiftUseCase(repo),
    deps: [VesselShiftResourceRepository],
  },
  {
    provide: ListVesselShiftResourceItemsUseCase,
    useFactory: (repo: VesselShiftResourceRepository) =>
      new ListVesselShiftResourceItemsUseCase(repo),
    deps: [VesselShiftResourceRepository],
  },
  {
    provide: ListVesselShiftResourceTypesUseCase,
    useFactory: (repo: VesselShiftResourceRepository) =>
      new ListVesselShiftResourceTypesUseCase(repo),
    deps: [VesselShiftResourceRepository],
  },
  {
    provide: GetVesselShiftResourceFormUseCase,
    useFactory: (repo: VesselShiftResourceRepository) =>
      new GetVesselShiftResourceFormUseCase(repo),
    deps: [VesselShiftResourceRepository],
  },
  {
    provide: SaveVesselShiftResourceItemsUseCase,
    useFactory: (repo: VesselShiftResourceRepository) =>
      new SaveVesselShiftResourceItemsUseCase(repo),
    deps: [VesselShiftResourceRepository],
  },
  {
    provide: GetVesselShiftResourceItemAuditLogsUseCase,
    useFactory: (repo: VesselShiftResourceRepository) =>
      new GetVesselShiftResourceItemAuditLogsUseCase(repo),
    deps: [VesselShiftResourceRepository],
  },
  {
    provide: DeleteVesselShiftResourceItemUseCase,
    useFactory: (repo: VesselShiftResourceRepository) =>
      new DeleteVesselShiftResourceItemUseCase(repo),
    deps: [VesselShiftResourceRepository],
  },
];
